import { SEOHeadTags, useSEO } from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import VideoCard from './components/VideoCard';
import ArticleCard from './components/ArticleCard';
import FAQSection from './components/FAQSection';
import { hotVideos, latestUpdates, articles } from '@/mocks/videoData';

export default function Home() {
  const seo = useSEO({
    title: '国产视频在线观看·高清免费全集播放',
    description: '国产视频在线观看，海量高清国产影视剧、综艺、纪录片免费在线播放。无需下载，随时随地流畅观看最新国产内容，支持手机、平板、电脑多端同步，每日更新热门国产视频资源。',
    keywords: '国产视频在线观看,国产高清视频在线观看,国产电视剧在线观看,国产综艺在线免费观看,国产电影在线观看高清,国产视频免费播放,最新国产视频在线',
    canonicalUrl: 'https://guochan.video/',
  });

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '国产视频在线观看',
    url: 'https://guochan.video/',
    description: '国产视频在线观看平台，提供海量高清国产影视剧、综艺、纪录片免费在线播放',
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '国产视频在线观看',
    url: 'https://guochan.video/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://guochan.video/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHeadTags data={seo} />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />

          <CategoryGrid />

          <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">精选高分国产视频，不容错过</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {hotVideos.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>
          </section>

          <section className="bg-background-100">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    最新更新
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">实时更新，精彩内容不错过</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {latestUpdates.map((video) => (
                  <VideoCard key={video.id} {...video} size="large" />
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  影视资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最新影视动态、深度行业观察</p>
              </div>
            </div>
            <div className="space-y-4">
              {articles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </section>

          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}